<template>
  <div class="payment-card">
    <template v-for="item in payList">
      <div
        :key="item.pId"
        v-if="
          item.phone === 'all' ||
            item.phone === system ||
            item.phone === browser ||
            (item.phone === 'phone' && system !== '')
        "
      >
        <div
          class="card-payment-item"
          :class="{
            bordermaincolor: payMode === item.pPaymentType && item.pId === pId
          }"
        >
          <div class="card-payment-item-info">
            <img
              v-if="
                item.pPaymentType === 'GOOGLE_PAY' ||
                  item.pPaymentType === 'STRIPE_GOOGLE'
              "
              :src="require('../../../assets/imgs/icon_googlepay.png')"
            />
            <img
              v-else-if="
                item.pPaymentType === 'APPLE_PAY' ||
                  item.pPaymentType === 'STRIPE_APPLE'
              "
              :src="require('../../../assets/imgs/icon_applepay.png')"
            />
            <img
              v-else-if="item.pPaymentType === 'PAYPAL'"
              :src="require('../../../assets/imgs/icon_paypal.png')"
            />
            <img
              v-else
              :src="require('../../../assets/imgs/icon_creditcard.png')"
            />
            <div class="content">
              <div class="title">{{ item.label }}</div>
            </div>
          </div>
          <div v-if="item.paymentConfig" class="card-payment-item-operate">
            <span
              class="card-payment-item-operate-text"
              @click="deletePayCard(item)"
              >{{ i18nConfirm.deletecard }}</span
            >
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex"

import { REMOVE_CARD } from "../../../apis/user"
import { PAYSTACK_CARD_DELETE } from "../../../apis/payment"

export default {
  props: {
    payList: {
      type: Array,
      default: () => {
        return []
      }
    },
    pId: {
      type: [String, Number],
      default: () => {
        return ""
      }
    },
    payMode: {
      type: String,
      default: () => {
        return ""
      }
    }
  },
  computed: {
    ...mapState(["system", "user", "qrcode", "browser"]),
    i18nConfirm() {
      return this.$t("confirm")
    },
    i18nMsg() {
      return this.$t("msg")
    }
  },
  methods: {
    // 删除支付卡
    deletePayCard(v) {
      // PayStack 保存卡走专用删除接口
      if (v.pSecuritycode === "PayStack") {
        this.$loading(true)
        this.$postV2(
          PAYSTACK_CARD_DELETE,
          { cardId: v.pId },
          (resp) => {
            this.$loading(false)
            this.$toast(this.i18nMsg.success)
            this.$emit("refresh")
          },
          (error) => {
            this.$loading(false)
            this.$confirm({
              title: this.i18nMsg.title,
              content: error,
              confirmText: this.i18nMsg.confirm,
              showCancel: false
            })
          }
        )
        return
      }
      this.$post(
        `${REMOVE_CARD + v.pId}`,
        {},
        (resp) => {
          this.$loading(false)
          console.log(resp)
          this.$toast(this.i18nMsg.success)
          this.$emit("refresh")
        },
        (error) => {
          this.$loading(false)
          console.log(error)
          this.$confirm({
            title: this.i18nMsg.title,
            content: this.i18nMsg.error,
            confirmText: this.i18nMsg.confirm,
            showCancel: false
          })
        }
      )
    }
  }
}
</script>

<style lang="less" scoped>
.payment-card {
  margin: 0;

  &-label {
    padding: 10px 30px;
    font-size: 36px;
    color: #41200f;
    font-weight: bold;
  }

  &-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 20px;
    border-radius: 16px;
    background: #fff;
    margin-top: 20px;
    border: 1px solid #e8e8e8;

    & img {
      width: 40px;
      height: 40px;
      object-fit: contain;
      flex-shrink: 0;
    }

    &-info {
      display: flex;
      align-items: center;
      flex: 1;
      min-width: 0;

      & .content {
        padding-left: 12px;
        min-width: 0;
      }

      & .title {
        font-size: 28px;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      & .sub_title {
        font-size: 24px;
        color: #999;
      }
    }
    &-operate {
      flex-shrink: 0;
      margin-left: 16px;
      &-text {
        display: inline-block;
        padding: 8px 16px;
        font-size: 24px;
        color: #fc0d1b;
        border: 1px solid #fc0d1b;
        border-radius: 10px;
        background: transparent;
        cursor: pointer;
        white-space: nowrap;
      }
    }
  }
}
</style>
